import React from "react";

import { Typography } from "@material-ui/core";

import { getPublishStatusText } from "utils/publish";

import { Container } from "./styles";

const PublishStatus = ({
  status,
  className,
}: {
  status: string;
  className?: string;
}) => (
  <Container status={status} className={className}>
    <Typography variant="body2">{getPublishStatusText(status)}</Typography>
  </Container>
);

export default PublishStatus;
